<template>
  <div>
    <slot :view="view" :setView="setView" :visibleCols="visibleCols" :toggleCol="toggleCol"></slot>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';

const props = defineProps({
  columns: { type: Array, default: () => [] },
});

const view = ref('picker');
const visibleCols = reactive(
  Object.fromEntries(props.columns.map((col) => [col, true]))
);

const setView = (v) => {
  view.value = v;
};

const toggleCol = (col) => {
  visibleCols[col] = !visibleCols[col];
};
</script>
